module.exports = __webpack_public_path__ + "img/cancel.4fa0e1f2.svg";